export function initTips(context) {
  $(context).find('[data-tooltip]').powerTip({
    smartPlacement: true,
    mouseOnToPopup: true,
  });
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/legacy/init/powertip.js